import {
  IsEmail,
  IsEnum,
  IsNotEmpty,
  IsOptional,
  IsString,
  IsUUID,
  ValidateIf,
} from 'class-validator';
import { PrincipalType } from './principalType.dto';

/**
 * Payload to create a row in `iam.principals` plus the matching subtype table
 * (`iam.users`, `iam.groups`, or `iam.service_accounts`).
 */
export class CreatePrincipalDto {
  @IsEnum(PrincipalType)
  type: PrincipalType;

  @IsOptional()
  @IsEmail()
  email?: string | null;

  @ValidateIf(o => o.type === PrincipalType.USER)
  @IsUUID()
  @IsNotEmpty()
  userId?: string;

  @ValidateIf(o => o.type === PrincipalType.GROUP)
  @IsString()
  @IsNotEmpty()
  displayName?: string;

  @ValidateIf(o => o.type === PrincipalType.GROUP)
  @IsString()
  @IsOptional()
  groupDescription?: string;

  @ValidateIf(o => o.type === PrincipalType.SERVICE_ACCOUNT)
  @IsString()
  @IsOptional()
  serviceAccountDescription?: string;
}
